// Date field validator

const constructDependantConstraint = (field) => ({
  attribute: field,
  message: 'is smaller than or equal to the start date',
  comparator: (v1, v2) => {
    return v1 > v2;
  }
});

export default ({
  mandatory = false,
  customError = null,
  dependant = null
}) => ({
  datetime: { dateOnly: true },
  equality: dependant && constructDependantConstraint(dependant),
  presence: mandatory && { message: customError }
});
